import script from "./SubmitDataModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitDataModal.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitDataModal.vue?vue&type=style&index=0&id=b08456a0&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b08456a0"]])

export default __exports__